import React from 'react';
import {
  WhiteModal,
  FlexBox,
  InfoParagraph,
  H1,
  PrimaryButton,
  SpacingBox,
} from '../Components';

export const ConfirmModal = ({
  title,
  description,
  setIsOpen,
  isOpen,
  buttonCaption,
  onConfirm,
}) => (
  <WhiteModal
    style={{ padding: 40 }}
    onCancel={() => setIsOpen(false)}
    isOpen={isOpen}
  >
    <FlexBox
      style={{ height: '100%' }}
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
    >
      <H1>{title}</H1>
      <SpacingBox marginTop='sm'>
        <InfoParagraph>{description}</InfoParagraph>
      </SpacingBox>
      <SpacingBox marginTop='md'>
        <PrimaryButton
          onClick={() => {
            onConfirm();
            setIsOpen(false);
          }}
          text={buttonCaption}
        />
      </SpacingBox>
    </FlexBox>
  </WhiteModal>
);

export default ConfirmModal;
